 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "6b121924" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0dd9bda7":1,"chunk-0303b6f2":1,"chunk-0542bb23":1,"chunk-05ee3505":1,"chunk-06326d46":1,"chunk-08d53cc4":1,"chunk-12491bb8":1,"chunk-141feab6":1,"chunk-161f64a8":1,"chunk-183b0a6b":1,"chunk-21345dc4":1,"chunk-279952da":1,"chunk-28224b0f":1,"chunk-79f7b78b":1,"chunk-035e8121":1,"chunk-67aa29d7":1,"chunk-0a1a3818":1,"chunk-05bf926a":1,"chunk-15f46eee":1,"chunk-35375c54":1,"chunk-36c35bcc":1,"chunk-41127eb7":1,"chunk-517dedb9":1,"chunk-81994784":1,"chunk-56e1a7ba":1,"chunk-7e1c7427":1,"chunk-9ad6b29c":1,"chunk-02b6805a":1,"chunk-3ab26255":1,"chunk-4870a6cc":1,"chunk-62ef0109":1,"chunk-6b0f8e96":1,"chunk-c6c23222":1,"chunk-2bb2582f":1,"chunk-656bc77e":1,"chunk-3108a1ed":1,"chunk-3338cd34":1,"chunk-34989971":1,"chunk-36b364d0":1,"chunk-1a30105a":1,"chunk-6fb1db1c":1,"chunk-392e9c89":1,"chunk-428d88d4":1,"chunk-48ceffd5":1,"chunk-49539fc6":1,"chunk-4b1e137c":1,"chunk-4bc75b30":1,"chunk-4d546518":1,"chunk-4f07715c":1,"chunk-51db906f":1,"chunk-56508753":1,"chunk-5b5e14d4":1,"chunk-6057e436":1,"chunk-60b8e624":1,"chunk-61981bd9":1,"chunk-0e5780bf":1,"chunk-119c929a":1,"chunk-16eea46c":1,"chunk-4bc08aa3":1,"chunk-113b01f2":1,"chunk-3abfb531":1,"chunk-54e52908":1,"chunk-747938f4":1,"chunk-856923aa":1,"chunk-ab5c9fe4":1,"chunk-fef2d126":1,"chunk-686a556c":1,"chunk-68701522":1,"chunk-6d1f82a9":1,"chunk-6dd361ae":1,"chunk-70976a78":1,"chunk-721b6018":1,"chunk-739ea9e8":1,"chunk-7ac1f114":1,"chunk-7ac2f646":1,"chunk-7f1b3e00":1,"chunk-8849681a":1,"chunk-8ab6b348":1,"chunk-8f9c7c34":1,"chunk-92aec8e6":1,"chunk-9a9771fa":1,"chunk-a28c1878":1,"chunk-b9901874":1,"chunk-c59b6470":1,"chunk-e75f1b36":1,"chunk-c7f139da":1,"chunk-f97cff56":1,"chunk-fcb59032":1,"chunk-0e70f6d0":1,"chunk-4d433258":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-00f07eb2":"31d6cfe0","chunk-0dd9bda7":"e1222f90","chunk-0303b6f2":"9092dab0","chunk-0542bb23":"cfe35d41","chunk-05ee3505":"a81bfca5","chunk-06326d46":"92d4ab9e","chunk-08d53cc4":"c978fb4a","chunk-0c7b2c68":"31d6cfe0","chunk-12491bb8":"14972a5b","chunk-141feab6":"496c157d","chunk-161f64a8":"4dec8ecb","chunk-183b0a6b":"b33aa63f","chunk-21345dc4":"bcebd232","chunk-279952da":"e05219fe","chunk-28224b0f":"cf1d82c4","chunk-2d0b2b47":"31d6cfe0","chunk-79f7b78b":"4c869c88","chunk-2d0b2ee5":"31d6cfe0","chunk-035e8121":"2f793d3d","chunk-2d0c510d":"31d6cfe0","chunk-67aa29d7":"fe323c98","chunk-0a1a3818":"e6e9d25c","chunk-05bf926a":"205f2d59","chunk-15f46eee":"c28000be","chunk-35375c54":"efdbcef4","chunk-36c35bcc":"cd0d0654","chunk-41127eb7":"dafc33b7","chunk-517dedb9":"dc7bc772","chunk-81994784":"336304aa","chunk-56e1a7ba":"adb85d17","chunk-619d7aac":"31d6cfe0","chunk-7e1c7427":"b1673117","chunk-9ad6b29c":"f680d13f","chunk-02b6805a":"da49e628","chunk-3ab26255":"5238259d","chunk-4870a6cc":"26a2be14","chunk-62ef0109":"60999713","chunk-6b0f8e96":"dc924cb4","chunk-c6c23222":"1fdd0901","chunk-2bb2582f":"ea684d97","chunk-2d0c8206":"31d6cfe0","chunk-2d0d4051":"31d6cfe0","chunk-656bc77e":"be37ec8f","chunk-2d0e9702":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-3108a1ed":"ac39bffa","chunk-3338cd34":"c978fb4a","chunk-34989971":"70944986","chunk-36b364d0":"9444cf77","chunk-1a30105a":"c0edcdee","chunk-6fb1db1c":"81bf7003","chunk-392e9c89":"bccf5d8e","chunk-428d88d4":"7b594e3d","chunk-4463fdfe":"31d6cfe0","chunk-48ceffd5":"25fddabf","chunk-49539fc6":"fac7ca08","chunk-4b1e137c":"b0dc754c","chunk-2d0ae9a7":"31d6cfe0","chunk-4bc75b30":"c63ab63e","chunk-4d546518":"e9521188","chunk-4f07715c":"32b4a5cd","chunk-51db906f":"6a809503","chunk-56508753":"28c24f36","chunk-5b5e14d4":"0eb5128d","chunk-6057e436":"b33aa63f","chunk-60b8e624":"07187c5e","chunk-61981bd9":"cb35d6e4","chunk-0e5780bf":"a5234848","chunk-119c929a":"7688b879","chunk-16eea46c":"b8da32d5","chunk-4bc08aa3":"459d5954","chunk-113b01f2":"0e62e291","chunk-3abfb531":"5360cede","chunk-54e52908":"de989f6a","chunk-747938f4":"fcba653a","chunk-856923aa":"73b81ab5","chunk-ab5c9fe4":"e48d55b5","chunk-fef2d126":"672bc62b","chunk-686a556c":"2c099a52","chunk-68701522":"a37d274b","chunk-6d1f82a9":"a91b1ac4","chunk-6dd361ae":"7bd47d96","chunk-70976a78":"70124683","chunk-721b6018":"496c157d","chunk-739ea9e8":"1c59bd9c","chunk-74c48a5b":"31d6cfe0","chunk-7ac1f114":"50881934","chunk-7ac2f646":"8d3c9cfb","chunk-7f1b3e00":"fdff0fbc","chunk-8849681a":"995c8cd8","chunk-8ab6b348":"2e8340e5","chunk-8f9c7c34":"96b24a5f","chunk-92aec8e6":"228a108f","chunk-9a9771fa":"048aad50","chunk-a28c1878":"a2aad21b","chunk-b9901874":"d13c34be","chunk-c59b6470":"80b4c4ce","chunk-e75f1b36":"b0b99a59","chunk-c7f139da":"9f606c55","chunk-cf3b0bda":"31d6cfe0","chunk-f97cff56":"b33aa63f","chunk-fcb59032":"f2217965","chunk-0e70f6d0":"f497f98d","chunk-4d433258":"d5d04ea6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
